import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Moon11pm = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00003 12.7499C10.6234 12.7499 12.75 10.6233 12.75 7.99997C12.75 5.37663 10.6234 3.25 8.00003 3.25C5.37669 3.25 3.25006 5.37663 3.25006 7.99997C3.25006 10.6233 5.37669 12.7499 8.00003 12.7499ZM8.00003 13.9999C11.3137 13.9999 14 11.3137 14 7.99997C14 4.68628 11.3137 2 8.00003 2C4.68634 2 2.00006 4.68628 2.00006 7.99997C2.00006 11.3137 4.68634 13.9999 8.00003 13.9999Z"
        fill="currentColor"
      />
      <path
        d="M11.2348 12.1348C12.762 12.1348 14 10.2836 14 7.99997C14 5.71638 12.762 3.86523 11.2348 3.86523C9.70758 3.86523 8.46954 5.71645 8.46954 8.00003C8.46954 10.2836 9.70758 12.1348 11.2348 12.1348Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Moon11pm;
